import React from 'react';
import { Link } from 'react-router-dom';

const personalInfoData = [
    {
        id: 1,
        title: 'Birthday',
        data: '10 August 1997'
    },
    {
        id: 2,
        title: 'Age',
        data: 23
    },
    {
        id: 3,
        title: 'Portfolio',
        data: 'imsamrat7.web.app'
    }, {
        id: 4,
        title: 'Email',
        data: 'imsamrat24@gmail.com'
    }, {
        id: 5,
        title: 'Passion',
        data: 'Development'
    }, {
        id: 6,
        title: 'Phone',
        data: '+88 01610 726 728'
    }, {
        id: 7,
        title: 'City',
        data: 'Dhaka'
    }, {
        id: 8,
        title: 'Freelance',
        data: 'Available'
    }
]

const PersonalInfo = () => {
    return (
        <div data-aos="fade-left" className="personal-info padd-15">
            <h3 className="padd-15 about-info-title">Personal Info</h3>
            <div className="row">
                {
                    personalInfoData.map(info => <div key={info.id} className="info-item padd-15">
                        <p>{info.title} : <span>{info.data}</span></p>
                    </div>)
                }
            </div>
            <div className="row">
                <div className="buttons padd-15">
                    <a href="https://drive.google.com/uc?export=download&amp;id=160-JQENxKGJUySvYXnVctP6d9MeHgLwB" role="button" target="_blank" className="btn">Download Resume</a>
                    <Link to="/contact" className="btn hire-me">Hire Me</Link>
                </div>
            </div>
        </div>
    );
};

export default PersonalInfo;